import { useEffect } from "react";
import { Route, Routes } from "react-router-dom-v5-compat";
import type { NavigationFlow } from "@b2bportal/core-types";
import { ErrorBoundary, useNavigationFlow } from "@b2bportal/core-utilities";
import { DefaultFlightSlotProvider } from "../../slots";
import type { FlightConfig } from "../../utils/config";
import { FlightConfigProvider } from "../../utils/config";
import {
  FlightExchangeNavigationFlowProvider,
  type FlightExchangeSteps,
  useCoreFlightsExchangeFlow,
} from "./navigationFlow";

export interface FlightsExchangeAppProps {
  CheckoutPage: JSX.Element;
  flightConfig?: FlightConfig;
}

export const FlightsExchangeApp = (props: FlightsExchangeAppProps) => {
  const { CheckoutPage, flightConfig } = props;
  const coreFlightsExchangeFlow = useCoreFlightsExchangeFlow({ CheckoutPage });

  return (
    <FlightConfigProvider context={flightConfig ?? {}}>
      <FlightExchangeNavigationFlowProvider
        navigationFlow={coreFlightsExchangeFlow}
      >
        <ErrorBoundary errorPath={coreFlightsExchangeFlow.funnelPath}>
          <DefaultFlightSlotProvider>
            <div className="App">
              <ExchangeFlowRoutes navigationFlow={coreFlightsExchangeFlow} />
            </div>
          </DefaultFlightSlotProvider>
        </ErrorBoundary>
      </FlightExchangeNavigationFlowProvider>
    </FlightConfigProvider>
  );
};

interface ExchangeFlowRoutesProps {
  navigationFlow: NavigationFlow<FlightExchangeSteps>;
}

const ExchangeFlowRoutes = ({ navigationFlow }: ExchangeFlowRoutesProps) => {
  const { flow, setFlow } = useNavigationFlow<FlightExchangeSteps>();

  useEffect(() => {
    setFlow(navigationFlow);
  }, [navigationFlow, setFlow]);

  return (
    <Routes>
      {flow.stepOrder.map((stepId) => {
        const step = flow.steps[stepId];
        return (
          <Route
            key={step.id}
            path={step.relativePath}
            element={step.component}
          />
        );
      })}
    </Routes>
  );
};
